import React from 'react';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";

function Services() {
  return (
    <> 
    <Helmet>
    <meta charset="utf-8" />
    <title>Service | Eagle Eye Enterprises</title>
    <link
          rel="canonical"
          href="https://eagleeyeenterprises.co.in/"
        /> 
    <meta name="description" content="Eagle Eye Enterprises CCTV security services CCTV cameras are one of the important elements in securing our businesses and daily lives. We provide design and installation of end-to-end CCTV security systems right from cameras (both analog & IP) to network to NVR's to server/storage to power backup solution to monitoring solution etc. We also provide wireless camera solutions; we have everything you need to customize your business security. We provide Best Performance Surveillance Security Systems at competitive price"/>
    <meta name="keywords" content="eagle eye enterprises EEE, Kankarbhagh, Patna"/>
    </Helmet>
    {/* <!-- Page Header Start --> */}
   <div className="container-fluid page-ourservice py-3 mb-5">
  <div className="container py-5">
    <h1 className="display-3 text-white mb-3 animated slideInDown">Services</h1>
    <nav aria-label="breadcrumb animated slideInDown">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li> 
        <li className="breadcrumb-item text-white active" aria-current="page">Services</li>
      </ol>
    </nav>
  </div>
</div>
    {/* <!-- Page Header End --> */}


  {/* <!-- Service Start --> */}
  


<div className="container-xxl py-5">
  <div className="container">
              <div className="row g-4 portfolio-container">
      <div className="col-lg-4 col-md-6 portfolio-item first wow fadeInUp" data-wow-delay="0.1s">
        <div className="portfolio-inner" style={{backgroundColor: '#161e3c'}}>
          <img className="img-fluid w-100" src="assets/img/comm_img.jpg" alt=""/>
          <div className="text-center p-4">
            
            <h4 className="lh-base mb-0" style={{color:'#070808'}}>Commercial CCTV System</h4>
          </div>
          <div className="portfolio-text text-center bg-white p-4">
          <h4 className="lh-base mb-1" style={{color:'#e1b021'}}>Commercial CCTV System</h4>
           
            <p className="text-success mb-2" style={{fontWeight:'500'}}>Commercial CCTV systems are today more sophisticated than ever.A whole host of features are available to enhance the functionality and integration to your business.</p>
            
             
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 portfolio-item second wow fadeInUp" data-wow-delay="0.3s">
        <div className="portfolio-inner" style={{backgroundColor: '#161e3c'}}>
          <img className="img-fluid w-100" src="assets/img/biometric.jpeg" alt="" />
          <div className="text-center p-4">
                         <h4 className="lh-base mb-0" style={{color:'#070808'}}>Biometric Sensor</h4>
          </div>
          <div className="portfolio-text text-center bg-white p-4">
          <h4 className="lh-base mb-1" style={{color:'#e1b021'}}>Biometric Sensor</h4>
            <p className="text-success mb-2" style={{fontWeight:'500'}}>Biometric device for office provides structural way working. It enables the workforce to be more accurate, reliable, and punctual by acting as an attendance machine.</p>
            
            
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 portfolio-item first wow fadeInUp" data-wow-delay="0.5s">
        <div className="portfolio-inner" style={{backgroundColor: '#161e3c'}}>
          <img className="img-fluid w-100" src="assets/img/gps.jpg" alt="" />
          <div className="text-center p-4">
             
            <h4 className="lh-base mb-0" style={{color:'#070808'}}>GPS</h4>
          </div>
          <div className="portfolio-text text-center bg-white p-4">
          <h4 className="lh-base mb-1" style={{color:'#e1b021'}}>GPS</h4>
            <p className="text-success mb-2" style={{fontWeight:'500'}}>GPS information for preparing accurate surveys and maps, taking precise time measurements, tracking position or location, and for navigation. GPS works at all times and in almost all weather conditions.</p>
            
                      </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 portfolio-item second wow fadeInUp" data-wow-delay="0.1s">
        <div className="portfolio-inner" style={{backgroundColor: '#161e3c'}}>
          <img className="img-fluid w-100" src="assets/img/home-security-systems.jpg" alt="" />
          <div className="text-center p-4">
           
            <h4 className="lh-base mb-0" style={{color:'#070808'}}> Home/Office Security</h4>
          </div>
          <div className="portfolio-text text-center bg-white p-4">
          <h4 className="lh-base mb-1" style={{color:'#e1b021'}}> Home/Office Security</h4>
            <p className="text-success mb-2" style={{fontWeight:'500'}}>We install various cameras and other equipment for rendering these services in the best possible manner. Apart from this, the equipment installed by us are checked on regular intervals so as to ensure their efficient and reliable performance.</p>
            
            
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 portfolio-item first wow fadeInUp" data-wow-delay="0.3s">
        <div className="portfolio-inner" style={{backgroundColor: '#161e3c'}}>
          <img className="img-fluid w-100" src="assets/img/intercom.jpeg" alt="" />
          <div className="text-center p-4">
             
            <h4 className="lh-base mb-0" style={{color:'#070808'}}>Camera Intercom</h4>
          </div>
          <div className="portfolio-text text-center bg-white p-4">
          <h4 className="lh-base mb-1" style={{color:'#e1b021'}}>Camera Intercom</h4>
            <p className="text-success mb-2" style={{fontWeight:'500'}}>intercom systems with video monitoring capabilities present security teams, property owners and building tenants with the ability to view live and recorded images and so on. </p>
            
             
          </div>
        </div>
      </div>
          </div>
  </div>
</div>


    {/* <!-- Service End --> */}

  
    </> 
  )
}

export default Services